import { useFeedbackContext } from '../contexts/FeedbackContext'

export function useFeedbackSettings() {
  return useFeedbackContext()
}
